import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from '@ant-design/icons';
import styles from './styles/kpi-card.module.scss';

const KPICard = ({ title, value, changePercent, format = 'currency', index = 0 }) => {
    const isPositive = changePercent > 0;
    const isNegative = changePercent < 0;
    const isZero = changePercent === 0;

    const formatValue = () => {
        if (value === null || value === undefined) {
            return 'N/A';
        }
        
        if (format === 'currency') {
            return `$${value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        } else if (format === 'number') {
            return value.toLocaleString('en-US');
        } else if (format === 'days') {
            return `${value} Days`;
        }
        return value;
    };

    return (
        <div className={styles.container} style={{ animationDelay: `${0.2 + (index * 0.05)}s` }}>
            <div className={styles.title}>{title}</div>
            <div className={styles.value}>{formatValue()}</div>
            <div className={styles.change}>
                {changePercent !== null && changePercent !== undefined && (
                    <>
                        {isPositive && (
                            <>
                                <ArrowUpOutlined className={styles.iconUp} />
                                <span className={styles.percentUp}>{changePercent}%</span>
                            </>
                        )}
                        {isNegative && (
                            <>
                                <ArrowDownOutlined className={styles.iconDown} />
                                <span className={styles.percentDown}>{Math.abs(changePercent)}%</span>
                            </>
                        )}
                        {isZero && (
                            <>
                                <MinusOutlined className={styles.iconNeutral} />
                                <span className={styles.percentNeutral}>No change from last month</span>
                            </>
                        )}
                        {!isZero && (
                            <span className={styles.period}>up from last month</span>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default KPICard;

